import script from "./goRinSyo0054.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0054.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0054.vue?vue&type=style&index=0&id=23f57b7d&lang=scss"

const __exports__ = script;

export default __exports__